/* eslint-disable @typescript-eslint/no-magic-numbers */
import AppRoutes from 'AppRoutes';
import ApiStatus from 'components/ApiStatus';
import LoadingOrError from 'components/LoadingOrError';
import SomethingWentWrong from 'components/SomethingWentWrong';
import VersionMonitor from 'components/VersionMonitor';
import { ButtonDialogBoxProvider } from 'hooks/useButtonDialogBox';
import { DialogBoxProvider } from 'hooks/useDialogBox';
import { SnackbarProvider } from 'hooks/useSnackbar';
import logger from 'logger';
import type { ReactElement } from 'react';
import { Suspense, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';

export default function App(): ReactElement {
  const [showVersion, setShowVersion] = useState<boolean>(!!localStorage.getItem('showVersion'));
  useEffect(() => {
    window.enableReveal = () => {
      logger.log('Reveal enabled!');
      localStorage.setItem('revealEnabled', '1');
    };
    window.disableReveal = () => {
      logger.log('Reveal disabled!');
      localStorage.removeItem('revealEnabled');
    };
    window.showVersion = () => {
      logger.log('Version display enabled!');
      localStorage.setItem('showVersion', '1');
      setShowVersion(true);
    };
    window.hideVersion = () => {
      logger.log('Version display disabled!');
      localStorage.removeItem('showVersion');
      setShowVersion(false);
    };
    window.enableWarning = () => {
      logger.log('Warning enabled!');
      localStorage.setItem('showWarning', '1');
    };
    window.disableWarning = () => {
      logger.log('Warning disbled!');
      localStorage.removeItem('showWarning');
    };
  }, []);
  return (
    <ErrorBoundary
      FallbackComponent={SomethingWentWrong}
      // eslint-disable-next-line react/jsx-handler-names
      onError={(error: Error) => {
        logger.error(error);
        // Do something with the error, e.g. log to an external API like firebase or monitoring tool
      }}
    >
      <BrowserRouter>
        <Suspense fallback={<LoadingOrError />}>
          <SnackbarProvider>
            <DialogBoxProvider>
              <ButtonDialogBoxProvider>
                <AppRoutes />
                <ApiStatus />
              </ButtonDialogBoxProvider>
            </DialogBoxProvider>
          </SnackbarProvider>
        </Suspense>
      </BrowserRouter>
      {/* <ReactQueryDevtools position="bottom" /> */}
      {showVersion && <VersionMonitor />}
    </ErrorBoundary>
  );
}
